
// api.js
export const getServerURL = () => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL_PRODUCTION;
  // Ensure the URL ends with a trailing slash
  return baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
};

//REACT_APP_API_BASE_URL                - local
// REACT_APP_API_BASE_URL_TEST           - test dev
//REACT_APP_API_BASE_URL_PRODUCTION     - live
